export const FETCH_RESOURCE = 'fetchResource';